<template>
  <div class="wt2-sg">
    <div class="-left-bar-zoom">
      <div class="wt2-text-xl -title">Zoom</div>
      <div class="-subtitle">Select Zoom Type</div>
      <wt-radio-text
        :buttons="buttons"
        :value="effectType"
        @select="setEffectType"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters('assetEditor', ['tmpAGD', 'assetModel']),

    effectType() {
      return this.tmpAGD.effectType;
    },

    hasZoomOut() {
      return !this.assetModel.isWEBPAGE();
    },
  },

  data() {
    return {
      buttons: [
        { text: 'None', value: null },
        { text: 'Zoom In', value: 'ZOOM_IN' },
      ].concat(
        !this.$store.state.assetEditor.assetModel.isWEBPAGE()
          ? [{ text: 'Zoom Out', value: 'ZOOM_OUT' }]
          : []
      ),
    };
  },

  methods: {
    ...mapActions('assetEditor', ['track', 'changeCurrentPage']),
    ...mapMutations('assetEditor', ['setTMPAGD']),

    setEffectType: function (effectType) {
      if (this.effectType === effectType) return;
      this.setTMPAGD({ effectType });
      if (effectType === 'ZOOM_IN') {
        this.track({ e: 'selectedZoomIn' });
      } else if (effectType === 'ZOOM_OUT') {
        this.track({ e: 'selectedZoomOut' });
      }
    },

    cancel: function () {
      this.changeCurrentPage('preview');
    },
  },
};
</script>
